import { FC } from "react";

const UpdateClubConfigTable: FC<{
  data: { title: string; amount?: number; subLabel: string }[];
}> = ({ data }) => {
  return (
    <div className="withdrawal-proposal-table">
      {data.map((config) => {
        return (
          <div className="withdrawal-proposal-table__item" key={config.title}>
            <p className="withdrawal-proposal-table__label withdrawal-proposal-table__label-capitalise">
              {config.title}
            </p>
            <p className="withdrawal-proposal-table__value">
              {config.amount && <span>{config.amount}</span>} {config.subLabel}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default UpdateClubConfigTable;
